<div *ngIf="practicePathLog.oldData" style="width: 100%;">
    <div class = "data-title">
        Régi adat:
    </div>
    <div>
        <ngx-json-viewer
            [json]="practicePathLog.oldData"
        ></ngx-json-viewer>
    </div>
</div>
<div *ngIf="practicePathLog.newData" style="width: 100%;">
    <div class = "data-title">
        Új adat:
    </div>
    <div>
        <ngx-json-viewer
            [json]="practicePathLog.newData"
        ></ngx-json-viewer>
    </div>
</div>
<div *ngIf="hasNoLogData()" class = "no-data">
    A log nem rendelkezik megjeleníthető adattal.
</div>